<template>
 <div class="msg">
        <div class="reg-box">
            <div class="reg-title" v-text="K010_NewUser"></div>
            <div class="reg">
                <div class="reg-way">
                    <div id="regEmail" :class="email?'reg-selway fl':'fl'" @click="emailShow" v-text="K011_EmailReg"></div>
                    <div id="regPhone" v-show="false" :class="phone?'reg-selway fl':'fl'" @click="phoneShow" v-text="K012_PhoneReg"></div>
                </div>
                <div id="byEmail" :class="{hide:phone}">
                    <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K013_Email" v-text="K013_Email"></div>
                        <input type="text" class="reg-val fr" maxlength="63" v-model="emailAddress" @keyup="emailAddKeyup">
                    </div>
                    <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K003_Password" v-text="K003_Password"></div>
                        <input type="password" class="reg-val fr" maxlength="16" v-model="emailPwd">
                    </div>
                    <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K014_ConfirmPwd" v-text="K014_ConfirmPwd"></div>
                        <input type="password" class="reg-val fr" maxlength="16" v-model="emailConfirmPwd">
                    </div>
                    <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K016_VerCode" v-text="K016_VerCode"></div>
                        <div class="fr vercode-box">
                            <input type="text" class="reg-val vercode-val" v-model="emailVercode" @input="limitVercode($event)">
                            <span>{{validTimes}}</span>
                            <button type="button" class="vercode-btn fr" :title="K017_GetVerCodes" v-text="K017_GetVerCodes" @click="emailCerCode" :disabled="vercodeDisables"></button>
                        </div>
                    </div>
                </div>
                <div id="byPhone" :class="{hide:email}">
                     <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K015_Phone" v-text="K015_Phone"></div>
                        <input type="text" class="reg-val fr" style="width:calc(100% - 180px);" v-model="phoneUserName" @input="limitphoneUserName($event)">
                        <button type="button" class="fr" @click="phoneOpen" :title="phoneText" v-text="phoneText" style="width:60px;height:100%;border:none;box-sizing:border-box;outline:none;"></button>
                    </div>
                     <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K016_VerCode" v-text="K016_VerCode"></div>
                        <div class="fr vercode-box">
                            <input type="text" class="reg-val vercode-val" v-model="phoneVercode" @input="limitVercode($event)">
                            <span>{{validTime}}</span>
                            <button type="button" class="vercode-btn fr" :title="K017_GetVerCode" v-text="K017_GetVerCode" @click="regPhoneCerCode" :disabled="vercodeDisable"></button>
                        </div>
                    </div>
                    <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K003_Password" v-text="K003_Password"></div>
                        <input type="password" maxlength="32" class="reg-val fr" v-model="phonePwd">
                    </div>
                    <div class="reg-input cle">
                        <div class="reg-tip fl" :title="K014_ConfirmPwd" v-text="K014_ConfirmPwd"></div>
                        <input type="password" maxlength="32" class="reg-val fr" v-model="phoneConfirmPwd">
                    </div>
                </div>
                <div class="confirm-btn cle">
                    <button type="button" class="fl" @click="regConfirm" :title="K009_Register" v-text="K009_Register"></button>
                    <button type="button" class="fr" @click="regCancel" :title="K018_Cancel" v-text="K018_Cancel"></button>
                </div>
            </div>
        </div>
        <PhonePre v-show="phonePreShow" v-on:show="phoneSH" ref="phonePreL"></PhonePre>
    </div>
</template>
<script>
import setNew from '../assets/js/login'
import PhonePre from './PhonePre'
export default {
    name:"Register",
    components:{
        PhonePre:PhonePre
    },
    data(){
        return {
            email:true,
            phone:false,
            lang:'',
            K010_NewUser:'',
            K011_EmailReg:'',
            K012_PhoneReg:'',
            K013_Email:'',
            K003_Password:'',
            K014_ConfirmPwd:'',
            K015_Phone:'',
            K016_VerCode:'',
            K017_GetVerCode:'',
            K017_GetVerCodes:'',
            K009_Register:'',
            K018_Cancel:'',
            emailAddress:'',
            emailPwd:'',
            emailConfirmPwd:'',
            emailVercode:'',
            phoneUserName:'',
            phoneVercode:'',
            phonePwd:'',
            phoneConfirmPwd:'',
            validTime:'',
            validTimes:'',
            count:121,
            counts:122,
            vercodeDisable:false,
            vercodeDisables:false,
            pwdCheck:/^(?!\d+$)(?![a-zA-Z]+$)\S{6,20}$/,
            timer:'',
            timers:'',
            phonePreShow:false,
            phoneText:'+86'
        }
    },
    methods:{
        emailShow:function(){
            this.email = true;
            this.phone = false;
        },
        phoneShow:function(){
            this.email = false;
            this.phone = true;
        },
        emailCerCode:function(){
            if(this.emailAddress===''){
                alert(this.lang['K148_emailEmpty']);
                return false;
            };
            var oem=this.baseData.oem;
            var url=this.cloudName;
            var xml=setNew.getCodeNumber({
                oem:oem,
                phone:this.emailAddress,
                type:'auth-email',
                app:this.baseData.appID
            });
            var data=this.ajaxSet({
                ip:url,
                type:'auth/user',
                xml:xml
            });
            this.emailCerCodeResult(data.data);
        },
        emailCerCodeResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result == "0"){
                this.K017_GetVerCodes = this.lang['K111_SendSuccess'];
                this.vercodeDisables = true;
                this.timers =setInterval(function(){
                    this.counts--;
                    this.validTimes = this.counts + 's';
                    if(this.counts < 0){
                        this.clearTimer();
                    };
                }.bind(this),1000);
            }else{
                var key = this.promptInfo(result);
                alert(this.lang[key] == undefined ? key : this.lang[key]);
            };
        },
        regPhoneCerCode:function(){
            if(this.phoneUserName===''){
                alert(this.lang['K155_Mobile']);
                return false;
            };
            var oem=this.baseData.oem;
            var url=this.cloudName;
            var xml=setNew.getCodeNumber({
                oem:oem,
                phone:this.phoneText+this.phoneUserName,
                type:'auth-mobile',
                app:this.baseData.appID
            });
            var data=this.ajaxSet({
                ip:url,
                type:'auth/user',
                xml:xml
            });
            this.regPhoneCerCodeResult(data.data);
        },
        regPhoneCerCodeResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result == "0"){
                this.K017_GetVerCode = this.lang['K111_SendSuccess'];
                this.vercodeDisable = true;
                this.timer =setInterval(function(){
                    this.count--;
                    this.validTime = this.count + 's';
                    if(this.count < 0){
                        this.clearTimer();
                    };
                }.bind(this),1000);
            }else{
                var key = this.promptInfo(result);
                alert(this.lang[key] == undefined ? key : this.lang[key]);
            };
        },
        regConfirm:function(){
            var oem=this.baseData.oem;
            var url=this.cloudName;
            var str='';
            if(this.email){
                if(this.emailAddress == '')
                {
                    alert(this.lang['K148_emailEmpty']);
                    return;
                };
                var num=this.reg.user.num;
                var leng=this.StrByteCountFun(this.emailAddress);
                if(!(leng>=num[0]&&length<=num[1])){
                    alert(this.lang['K200_Limit']);
                    return;
                };
                if(!this.reg.user.limit.test(this.emailAddress)){
                    alert(this.lang['K201_Type']);
                    return;
                };
                if(this.emailAddress.indexOf('@')===-1){
                    alert(this.lang['K123_EmailCheck']);
                    return;
                };
                var pwdnum=this.reg.rPwd.num;
                var pwdleng=this.StrByteCountFun(this.emailPwd);
                if(!(pwdleng>=pwdnum[0]&&pwdleng<=pwdnum[1])){
                    alert(this.lang['K202_Limit']);
                    return;
                };
                if(!this.reg.rPwd.limit.test(this.emailPwd)){
                    alert(this.lang['K203_Type']);
                    return;
                };
                if(this.emailConfirmPwd != this.emailPwd)
                {
                    alert(this.lang['K114_PwdNoSame']);
                    return;
                };
                if(this.emailVercode===''){
                    alert(this.lang['K156_Verification']);
                    return false;
                };
                str=setNew.register({
                    oem:oem,
                    email:this.emailAddress,
                    type:'auth-email',
                    pwd:this.hashEncryption(this.emailConfirmPwd),
                    code:this.emailVercode
                });
            }else{
                if(this.phoneUserName===''){
                    alert(this.lang['K155_Mobile']);
                    return false;
                };
                if(this.phoneVercode===''){
                    alert(this.lang['K156_Verification']);
                    return false;
                };
                if(this.phoneConfirmPwd != this.phonePwd)
                {
                    alert(this.lang['K114_PwdNoSame']);
                    return;
                };
                if(!this.pwdCheck.test(this.phoneConfirmPwd))
                {
                    alert(this.lang['K003_Password']+' : '+this.lang['K113_LimitPwd']);
                    return;
                };
                str=setNew.register({
                    oem:oem,
                    mobile:this.phoneText+this.phoneUserName,
                    pwd:this.hashEncryption(this.phoneConfirmPwd),
                    type:'auth-mobile',
                    code:this.phoneVercode
                });
            };
            var data=this.ajaxSet({
                ip:url,
                type:'auth/user',
                xml:str
            });
            this.regConfirmResult(data.data);
        },
        regConfirmResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result == "0"){
                alert(this.lang['K221_Suc']); 
                this.emptyInput();
                this.$emit("regWayShow",false);
            }else{
                var key = this.promptInfo(result);
                alert(this.lang[key] == undefined ? key : this.lang[key]);
            };
        },
        regCancel:function(){
            this.$emit("regWayShow",false);
            this.emptyInput();
            this.clearTimer();
        },
        language:function(lan){
            this.lang=this.lanSave[lan];
            this.K010_NewUser = this.lang['K010_NewUser'];
            this.K011_EmailReg = this.lang['K011_EmailReg'];
            this.K012_PhoneReg = this.lang['K012_PhoneReg'];
            this.K013_Email = this.lang['K013_Email'];
            this.K003_Password = this.lang['K003_Password'];
            this.K014_ConfirmPwd = this.lang['K014_ConfirmPwd'];
            this.K015_Phone = this.lang['K015_Phone'];
            this.K016_VerCode = this.lang['K016_VerCode'];
            this.K017_GetVerCode = this.lang['K017_GetVerCode'];
            this.K017_GetVerCodes = this.lang['K017_GetVerCode'];
            this.K009_Register = this.lang['K009_Register'];
            this.K018_Cancel = this.lang['K018_Cancel'];
            this.$refs.phonePreL.lang(lan);
        },
        limitphoneUserName:function(event){
            var reg=/\d+/;
            if(reg.exec(this.phoneUserName)===null){
                this.phoneUserName ='';
            }else{
                this.phoneUserName =reg.exec(this.phoneUserName);
            };
        },
        limitVercode:function(event){
            // this.phoneVercode = event.target.value.replace(/[^\d]/g,'');
        },
        emptyInput:function(){
            this.emailAddress = '';
            this.emailPwd = '';
            this.emailConfirmPwd = '';
            this.emailVercode = '';
            this.phoneUserName = '';
            this.phoneVercode = '';
            this.phonePwd = '';
            this.phoneConfirmPwd = '';
            this.phoneText='+86';
        },
        clearTimer:function(){
            window.clearInterval(this.timer);
            window.clearInterval(this.timers);
            this.validTime = '';
            this.validTimes = '';
            this.count = 121;
            this.counts = 121;
            this.K017_GetVerCode = this.lang['K017_GetVerCode'];
            this.K017_GetVerCodes = this.lang['K017_GetVerCode'];
            this.vercodeDisable = false;
            this.vercodeDisables = false;
            if(this.phone)
            {
                // this.regDisable = true;
            }
        },
        emailAddKeyup:function(){
            //  this.emailAddress = this.emailAddress.replace(/[\u4e00-\u9fa5]/g,'');
        },
        phoneOpen:function(){
            this.phonePreShow=true;
            this.$refs.phonePreL.select(this.phoneText);
        },
        phoneSH:function(show){
            this.phonePreShow=false;
            if(show.show){
                this.phoneText=show.num;
            };
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .reg-box{
        width:400px;
        height:300px;
        background-color: #11366A;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-150px;
        margin-left:-200px;
        color:#fff;
        }
    .reg-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        font-size: 16px;
    }
    .reg{
        width:100%;
        height:calc(100% - 24px);
        padding:20px;
        box-sizing: border-box;
        }
    .reg-way{
        height: 24px;
        margin-bottom: 20px;
    }
    .reg-way div{
        font-size:14px;
        text-align: center;
        line-height: 24px;
        cursor:default;
    }
    .reg-way div:nth-child(2)
    {
        margin-left: 10px;
    }
    .reg-input{
        width:100%;
        height:24px;
    }
    .reg-input+.reg-input{
        margin-top:10px;
    }
     .reg-tip{
        width:120px;
        height:100%;
        line-height:24px;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .reg-val{
        width:calc(100% - 120px);
        height: 100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .vercode-box{
        width:calc(100% - 120px);
        height: 100%;
        box-sizing: border-box;
        outline: none;
    }
    .vercode-val{
        width: 100px;
    }
    .vercode-btn{
        height: 100%;
        width: 90px;
        color:#fff;
        background-color:#0C5297;
        border:none;
        border-radius: 5px;
        outline: none;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .confirm-btn{
        width:100%;
        height:30px;
        margin-top:30px;
    }
    .confirm-btn button{
        width:80px;
        height:100%;
        color:#fff;
        background-color:#0C5297;
        border:none;
        border-radius: 5px;
        outline: none;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .reg-way .reg-selway::after{
        width:50px;
        height:2px;
        display: block;
        content:'';
        margin:0 auto;
        border-bottom:2px solid #6AD4F8;
  }
    .reg input{
        color:#bbc2d2;
        background-color:#1b4180;
    }
    .confirm-btn button:hover,.vercode-btn:hover{
        background-color:#0193FF;
    }
</style>
<style scoped>
    @import '../assets/css/loginPop.css';  
</style>




// WEBPACK FOOTER //
// src/components/Register.vue